'use strict';

function ctrl($scope, Global, $http, timeFormat, fetchStream, $window, $location, socketIo, generateId, settings, usSpinnerService, $state, $stateParams) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    model.tableIdentifiers = {
        key: false,
        id: false
    };
    model.sidebarIdentifiers = {
        key: false,
        id: false
    };

    // LIST OF UNIQUE COLUMNS IN DISPLAYED TABLES:

    // fetch counts for various types.
    // fetch records for default types.
    // disable searchbar in header
    // duplicate table stuffing (include exclude)
    // based on what is clicked and active
    // fire counting function

    // set current time into the url if it exists in the stateParams
    if ($stateParams.time) {
        $location.search($stateParams.time); // add the time back to the url
    }

    // local access to identifiers

    // page sidebar
    (function setSidebarItems() {
        model.sidebarItems = [//{
            //title: 'Bacnet',
            //select: 'bacnet',
            //count: 0,
            //doneLoading: false,
        //}, {
        {
            title: 'Connections',
            select: 'conn',
            count: 0,
            doneLoading: false,
        }, {
            title: 'DHCP',
            select: 'dhcp',
            count: 0,
            doneLoading: false,
        }, {
            title: 'DPD',
            select: 'dpd',
            count: 0,
            doneLoading: false,
        }, {
            title: 'DNS',
            select: 'dns',
            count: 0,
            doneLoading: false,
        },// {
          //  title: 'DNP3',
          //  select: 'dnp3',
          //  count: 0,
          //  doneLoading: false,
          //}, {
          //  title: 'Enip',
          //  select: 'enip',
          //  count: 0,
          //  doneLoading: false,
          //}, {
        {
            title: 'Events',
            select: 'events',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Files',
            select: 'files',
            count: 0,
            doneLoading: false,
        }, {
            title: 'FTP',
            select: 'ftp',
            count: 0,
            doneLoading: false,
        }, {
            title: 'HTTP',
            select: 'http',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Intel',
            select: 'intel',
            count: 0,
            doneLoading: false,
        }, {
            title: 'IRC',
            select: 'irc',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Kerberos',
            select: 'kerberos',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Known Services',
            select: 'known_services',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Known Certs',
            select: 'known_certs',
            count: 0,
            doneLoading: false,
        }, //{
           // title: 'Modbus',
           // select: 'modbus',
           // count: 0,
           // doneLoading: false,
        //}, {
        {
            title: 'MySQL',
            select: 'mysql',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Notice',
            select: 'notice',
            count: 0,
            doneLoading: false,
        }, {
            title: 'NTLM',
            select: 'ntlm',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Portable Executable',
            select: 'pe',
            count: 0,
            doneLoading: false,
        },// {
          //  title: 'Profinet',
          //  select: 'profinet',
          //  count: 0,
          //  doneLoading: false,
        //}, {
        {
            title: 'RDP',
            select: 'rdp',
            count: 0,
            doneLoading: false,
        }, {
            title: 'SMTP',
            select: 'smtp',
            count: 0,
            doneLoading: false,
        }, {
            title: 'SSH',
            select: 'ssh',
            count: 0,
            doneLoading: false,
        }, {
            title: 'SSL',
            select: 'ssl',
            count: 0,
            doneLoading: false,
        }, {
            title: 'SIP',
            select: 'sip',
            count: 0,
            doneLoading: false,
        }, {
            title: 'SNMP',
            select: 'snmp',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Syslog',
            select: 'syslog',
            count: 0,
            doneLoading: false,
        }, //{
           // title: 'S7Comm',
           // select: 's7comm',
           // count: 0,
           // doneLoading: false,
        //}, {
        {
            title: 'Traceroute',
            select: 'traceroute',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Tunnel',
            select: 'tunnel',
            count: 0,
            doneLoading: false,
        }, {
            title: 'Weird',
            select: 'weird',
            count: 0,
            doneLoading: false,
        }, {
            title: 'x509',
            select: 'x509',
            count: 0,
            doneLoading: false,
        }];
    })()

    // set inital mode and run inital query
    let tableSettings = {
        ntlm: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'ID',
                select: 'uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'User name',
                select: 'username',
                dView: true
            }, {
                title: 'Host name',
                select: 'hostname',
                dView: true
            }, {
                title: 'Domain name',
                select: 'domainname',
                dView: true
            }, {
                title: 'NetBios name',
                select: 'server_nb_computer_name',
                dView: true
            }, {
                title: 'DNS name',
                select: 'server_dns_computer_name',
                dView: true
            }, {
                title: 'Tree name',
                select: 'server_tree_name',
                dView: true
            }, {
                title: 'Success',
                select: 'success',
                dView: true
            } ],
            searchCategories: {
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'orig_port': 'Orig Port',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
            },
            title: 'NTLM',
            sort: {
                direction: '-',
                col: 'time'
            },
            grouping: ['uid'],
        },
        bacnet: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'uid',
                dView: true
            }, {
                title: 'BVLC Function',
                select: 'bvlc_function',
                dView: true
            }, {
                title: 'BVLC Length',
                select: 'bvlc_len',
                dView: true
            }, {
                title: 'APDU Type',
                select: 'apdu_type',
                dView: true
            }, {
                title: 'Service Choice',
                select: 'service_choice',
                dView: true
            }, {
                title: 'Data',
                select: 'data',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'id_orig_h',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'id_orig_p',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'id_resp_h',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'id_resp_p',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, ],
            searchCategories: {
                'bvlc_function': 'BVLC Function',
                'bvlc_len': 'BVLC Length',
                'apdu_type': 'APDU Type',
                'id_orig_h': 'Orig IP',
                'time': 'Time',
                'orig_hostname': 'Orig Hostname',
                'id_orig_p': 'Orig Port',
                'orig_user': 'Orig User',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'id_resp_h': 'Resp IP',
                'id_resp_p': 'Resp Port',
            },
            title: 'Bacnet',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        conn: {
            columns: [
                {
                    title: 'Time',
                    select: 'time',
                    dView: true
                }, {
                    title: 'Connection UID',
                    select: 'conn_uid',
                    dView: true
                }, {
                    title: 'Duration',
                    select: 'duration',
                    dView: false
                },
                // { title: 'Connection State', select: 'conn_state', dView: true },
                {
                    title: 'Vector',
                    select: 'vector',
                    dView: true
                }, {
                    title: 'Orig IP',
                    select: 'orig_ip',
                    dView: true
                }, {
                    title: 'Orig Port',
                    select: 'orig_port',
                    dView: true
                }, {
                    title: 'Orig Hostname',
                    select: 'orig_hostname',
                    dView: true
                }, {
                    title: 'Orig User',
                    select: 'orig_user',
                    dView: true
                }, {
                    title: 'Orig Stealth',
                    select: 'orig_stealth',
                    dView: false
                }, {
                    title: 'Orig Country',
                    select: 'orig_country',
                    dView: true
                }, {
                    title: 'Orig CC',
                    select: 'orig_cc',
                    dView: false
                }, {
                    title: 'Orig City',
                    select: 'orig_city',
                    dView: false
                }, {
                    title: 'Orig ASN Name',
                    select: 'orig_asn_name',
                    dView: true
                }, {
                    title: 'Resp IP',
                    select: 'resp_ip',
                    dView: true
                }, {
                    title: 'Resp Port',
                    select: 'resp_port',
                    dView: true
                }, {
                    title: 'Resp Hostname',
                    select: 'resp_hostname',
                    dView: true
                }, {
                    title: 'Resp User',
                    select: 'resp_user',
                    dView: true
                }, {
                    title: 'Resp Stealth',
                    select: 'resp_stealth',
                    dView: true
                }, {
                    title: 'Resp Country',
                    select: 'resp_country',
                    dView: true
                }, {
                    title: 'Resp CC',
                    select: 'resp_cc',
                    dView: false
                }, {
                    title: 'Resp City',
                    select: 'resp_city',
                    dView: false
                }, {
                    title: 'Resp ASN Name',
                    select: 'resp_asn_name',
                    dView: true
                }, {
                    title: 'Payload Ratio',
                    select: 'breakdown',
                    dView: true
                }, {
                    title: 'Origin Payload',
                    select: 'bytes_orig',
                    dView: true
                }, {
                    title: 'Responder Payload',
                    select: 'bytes_resp',
                    dView: true
                }, {
                    title: 'Origin Packets',
                    select: 'packets_orig',
                    dView: true
                }, {
                    title: 'Responder Packets',
                    select: 'packets_resp',
                    dView: true
                }, {
                    title: 'Protocol',
                    select: 'proto',
                    dView: true
                }, {
                    title: 'Service',
                    select: 'service',
                    dView: true
                }, {
                    title: 'Layer 7 App',
                    select: 'l7_app',
                    dView: true
                }, {
                    title: 'IOC Count',
                    select: 'ioc_count',
                    dView: true
                }, {
                    title: 'IOC Class',
                    select: 'ioc_class',
                    dView: true
                }, {
                    title: 'IOC Rule',
                    select: 'ioc_rule',
                    dView: true
                }, {
                    title: 'IOC Type',
                    select: 'ioc_type',
                    dView: true
                }, {
                    title: 'IOC Stage',
                    select: 'ioc_stage',
                    dView: false
                }, {
                    title: 'IOC Severity',
                    select: 'ioc_severity',
                    dView: true
                }, {
                    title: 'IOC Confidence',
                    select: 'ioc_confidence',
                    dView: true
                }, {
                    title: 'IOC ID',
                    select: 'ioc_id',
                    dView: true
                }, {
                    title: 'Proxy Rule',
                    select: 'proxy_rule',
                    dView: true
                }, {
                    title: 'Sensor',
                    select: 'sensor',
                    dView: true
                },
            ],
            searchCategories: {
                'vector': 'Vector',
                'conn_uid': 'Connection UID',
                // 'conn_state': 'Connection State',
                'orig_ip': 'Orig IP',
                'orig_port': 'Orig Port',
                'orig_hostname': 'Orig Hostname',
                'orig_user': 'Orig User',
                'orig_asn_name': 'Orig ASN Name',
                'orig_cc': 'Orig Flag',
                'orig_city': 'Orig City',
                'orig_country': 'Orig Country',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'resp_hostname': 'Resp Hostname',
                'resp_user': 'Resp User',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'proto': 'Protocol',
                'service': 'Service',
                'l7_app': 'Layer 7 App',
                'ioc_class': 'IOC Class',
                // 'ioc_count' : "IOC Count",
                'ioc_id': 'IOC ID',
                'ioc_severity': 'IOC Severity',
                'ioc_rule': 'IOC Rules',
                'ioc_stage': 'IOC Stage',
                'ioc_type': 'IOC Type',
                'proxy_rule': 'Proxy Rule',
                'sensor': 'Sensor',
            },
            title: 'Connections',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        dhcp: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Orig Mac',
                select: 'orig_mac',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Assigned IP',
                select: 'assigned_ip',
                dView: true
            }, {
                title: 'Trans ID',
                select: 'trans_id',
                dView: true
            }, {
                title: 'Lease Time',
                select: 'lease_time',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'assigned_ip': 'Assigned IP',
                'conn_uid': 'Connection UID',
                'orig_mac': 'Orig MAC',
                'orig_port': 'Orig Port',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
            },
            title: 'DHCP',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        dns: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, {
                title: 'Protocol',
                select: 'proto',
                dView: true
            }, {
                title: 'Answers',
                select: 'answers',
                dView: true
            }, {
                title: 'AA',
                select: 'aa',
                dView: true
            }, {
                title: 'Query Class',
                select: 'qclass',
                dView: true
            }, {
                title: 'Query Class Name',
                select: 'qclass_name',
                dView: true
            }, {
                title: 'Query Type',
                select: 'qtype',
                dView: true
            }, {
                title: 'Query Type Name',
                select: 'qtype_name',
                dView: true
            }, {
                title: 'Query',
                select: 'query',
                dView: true
            }, {
                title: 'RA',
                select: 'ra',
                dView: true
            }, {
                title: 'Return Code',
                select: 'rcode',
                dView: true
            }, {
                title: 'Return Code Name',
                select: 'rcode_name',
                dView: true
            }, {
                title: 'RD',
                select: 'rd',
                dView: true
            }, {
                title: 'Rejected',
                select: 'rejected',
                dView: true
            }, {
                title: 'TC',
                select: 'tc',
                dView: true
            }, {
                title: 'Trans ID',
                select: 'trans_id',
                dView: true
            }, {
                title: 'TTLs',
                select: 'ttls',
                dView: true
            }, {
                title: 'Z',
                select: 'z',
                dView: true
            }, {
                title: 'IOC Severity',
                select: 'ioc_severity',
                dView: true
            }, {
                title: 'IOC Count',
                select: 'ioc_count',
                dView: true
            }, {
                title: 'IOC Class',
                select: 'ioc_class',
                dView: true
            }, {
                title: 'IOC Confidence',
                select: 'ioc_confidence',
                dView: true
            }, {
                title: 'IOC ID',
                select: 'ioc_id',
                dView: true
            }, {
                title: 'IOC Rule',
                select: 'ioc_rule',
                dView: true
            }, {
                title: 'IOC Stage',
                select: 'ioc_stage',
                dView: true
            }, {
                title: 'IOC Type',
                select: 'ioc_type',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'aa': 'AA',
                'answers': 'Answers',
                'conn_uid': 'Connection UID',
                'ioc_class': 'IOC Class',
                // 'ioc_count' : "IOC Count",
                'ioc_id': 'IOC ID',
                'ioc_severity': 'IOC Severity',
                'ioc_rule': 'IOC Rules',
                'ioc_stage': 'IOC Stage',
                'ioc_type': 'IOC Type',
                'orig_hostname': 'Orig Hostname',
                'orig_port': 'Orig Port',
                'orig_user': 'Orig User',
                'proto': 'Protocol',
                'qclass': 'Query Class',
                'qclass_name': 'Query Class Name',
                'qtype': 'Query Type',
                'qtype_name': 'Query Type Name',
                'query': 'Query',
                'ra': 'RA',
                'rcode': 'Return Code',
                'rcode_name': 'Return Code Name',
                'rd': 'RD',
                'rejected': 'Rejected',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
                'tc': 'TC',
                'trans_id': 'Trans ID',
                'ttls': 'TTLs',
                'z': 'Z',
            },
            title: 'DNS',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        dpd: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Protocol',
                select: 'proto',
                dView: true
            }, {
                title: 'Analyzer',
                select: 'analyzer',
                dView: true
            }, {
                title: 'Failure Reason',
                select: 'failure_reason',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'analyzer': 'Analyzer',
                'conn_uid': 'Connection UID',
                'failure_reason': 'Failure Reason',
                'orig_port': 'Orig Port',
                'proto': 'Protocol',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
            },
            title: 'DPD',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        dnp3: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'id_orig_h',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'id_orig_p',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'id_resp_h',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'id_resp_p',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, {
                title: 'Fc Request',
                select: 'fc_request',
                dView: true
            }, {
                title: 'Fc Reply',
                select: 'fc_reply',
                dView: true
            },{
                title: 'Iin',
                select: 'iin',
                dView: true
            },],
            searchCategories: {
                'fc_request': 'Fc Request',
                'fc_reply': 'Fc Reply',
                'inn': 'Inn',
                'id_orig_h': 'Orig IP',
                'time': 'Time',
                'orig_hostname': 'Orig Hostname',
                'id_orig_p': 'Orig Port',
                'orig_user': 'Orig User',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'id_resp_h': 'Resp IP',
                'id_resp_p': 'Resp Port',
            },
            title: 'DNP3',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        enip: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'uid',
                dView: true
            }, {
                title: 'Command',
                select: 'command',
                dView: true
            }, {
                title: 'Length',
                select: 'length',
                dView: true
            }, {
                title: 'Session Handle',
                select: 'session_handle',
                dView: true
            }, {
                title: 'Sender Context',
                select: 'sender_context',
                dView: true
            }, {
                title: 'Status',
                select: 'status',
                dView: true
            }, {
                title: 'Options',
                select: 'options',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'id_orig_h',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'id_orig_p',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'id_resp_h',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'id_resp_p',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, ],
            searchCategories: {
                'command': 'Command',
                'session_handle': 'Session Handle',
                'status': 'Status',
                'sender_context': 'Sender Context',
                'id_orig_h': 'Orig IP',
                'time': 'Time',
                'orig_hostname': 'Orig Hostname',
                'id_orig_p': 'Orig Port',
                'orig_user': 'Orig User',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'id_resp_h': 'Resp IP',
                'id_resp_p': 'Resp Port',
            },
            title: 'enip',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        events: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Event Full',
                select: 'event_full',
                dView: true
            }, {
                title: 'Event ID',
                select: 'event_id',
                dView: true
            }, {
                title: 'Event Level',
                select: 'event_level',
                dView: true
            }, {
                title: 'Event Source',
                select: 'event_src',
                dView: true
            }, {
                title: 'Event Type',
                select: 'event_type',
                dView: true
            }, {
                title: 'Event User',
                select: 'event_user',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'event_full': 'Event Full',
                'event_id': 'Event ID',
                'event_src': 'Event Source',
                'event_type': 'Event Type',
                'event_user': 'Event User',
                'orig_hostname': 'Orig Hostname',
                'orig_user': 'Orig User',
                'sensor': 'Sensor',
            },
            title: 'Events',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        files: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Source',
                select: 'source',
                dView: true
            }, {
                title: 'Connection UIDs',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'File UID',
                select: 'file_uid',
                dView: true
            }, {
                title: 'TX IP',
                select: 'tx_hosts',
                dView: true
            }, {
                title: 'RX IP',
                select: 'rx_hosts',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, {
                title: 'MIME',
                select: 'mime',
                dView: true
            }, {
                title: 'Size',
                select: 'size',
                dView: true
            }, {
                title: 'MD5',
                select: 'md5',
                dView: true
            }, {
                title: 'Extracted File',
                select: 'extracted_file',
                dView: true
            }, {
                title: 'Name',
                select: 'name',
                dView: true
            }, {
                title: 'SHA1',
                select: 'sha1',
                dView: true
            }, {
                title: 'SHA256',
                select: 'sha256',
                dView: true
            }, {
                title: 'HTTP Host',
                select: 'http_host',
                dView: true
            }, {
                title: 'HTTP Referrer',
                select: 'http_referrer',
                dView: true
            }, {
                title: 'HTTP URI',
                select: 'http_uri',
                dView: true
            }, {
                title: 'HTTP User Agent',
                select: 'http_user_agent',
                dView: true
            }, {
                title: 'Protocol',
                select: 'proto',
                dView: true
            }, {
                title: 'IOC Class',
                select: 'ioc_class',
                dView: true
            }, {
                title: 'IOC Confidence',
                select: 'ioc_confidence',
                dView: true
            }, {
                title: 'IOC Count',
                select: 'ioc_count',
                dView: true
            }, {
                title: 'IOC ID',
                select: 'ioc_id',
                dView: true
            }, {
                title: 'IOC Rule',
                select: 'ioc_rule',
                dView: true
            }, {
                title: 'IOC Severity',
                select: 'ioc_severity',
                dView: true
            }, {
                title: 'IOC Stage',
                select: 'ioc_stage',
                dView: true
            }, {
                title: 'IOC Type',
                select: 'ioc_type',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, {
                title: 'Duration',
                select: 'duration',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'source': 'Source',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'conn_uid': 'Connection UID',
                'extracted_file': 'Extracted File',
                'file_uid': 'File UIDs',
                'http_host': 'HTTP Host',
                'http_referrer': 'HTTP Referrer',
                'http_uri': 'HTTP URI',
                'http_user_agent': 'HTTP User Agent',
                'ioc_class': 'IOC Class',
                // 'ioc_count' : "IOC Count",
                'ioc_id': 'IOC ID',
                'ioc_severity': 'IOC Severity',
                'ioc_rule': 'IOC Rules',
                'ioc_stage': 'IOC Stage',
                'ioc_type': 'IOC Type',
                'orig_hostname': 'Orig Hostname',
                'orig_user': 'Orig User',
                'md5': 'MD5',
                'mime': 'MIME',
                'name': 'Name',
                'proto': 'Protocol',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'resp_ip': 'Resp IP',
                'sensor': 'sensor',
                'sha1': 'SHA1',
                'sha256': 'SHA256',
                'tx_hosts': 'TX IP',
                'rx_hosts': 'RX IP',
            },
            title: 'File',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        ftp: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, {
                title: 'Argument',
                select: 'arg',
                dView: true
            }, {
                title: 'MIME Type',
                select: 'mime_type',
                dView: true
            }, {
                title: 'Password',
                select: 'password',
                dView: true
            }, {
                title: 'Command',
                select: 'command',
                dView: true
            }, {
                title: 'DC Orig IP',
                select: 'dc_orig_h',
                dView: true
            }, {
                title: 'DC Passive',
                select: 'dc_passive',
                dView: true
            }, {
                title: 'DC Resp IP',
                select: 'dc_resp_h',
                dView: true
            }, {
                title: 'DC Resp Port',
                select: 'dc_resp_p',
                dView: true
            }, {
                title: 'File Size',
                select: 'file_size',
                dView: true
            }, {
                title: 'FTP LAN User',
                select: 'user',
                dView: true
            }, {
                title: 'File UID',
                select: 'fuid',
                dView: true
            }, {
                title: 'Reply Code',
                select: 'reply_code',
                dView: true
            }, {
                title: 'Reply Message',
                select: 'reply_msg',
                dView: true
            }, {
                title: 'sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'arg': 'Argument',
                'command': 'Command',
                'conn_uid': 'Connection UID',
                'dc_orig_h': 'DC Orig IP',
                'dc_passive': 'DC Passive',
                'dc_resp_h': 'DC Resp IP',
                'dc_resp_p': 'DC Resp Port',
                'user': 'FTP LAN User',
                'fuid': 'File UID',
                'orig_hostname': 'Orig Hostname',
                'orig_port': 'Orig Port',
                'orig_user': 'Orig User',
                'mime_type': 'MIME Type',
                'password': 'Password',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'resp_ip': 'Resp IP',
                'reply_code': 'Reply Code',
                'reply_msg': 'Reply Message',
                'sensor': 'Sensor',
            },
            title: 'FTP',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        http: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, {
                title: 'Depth',
                select: 'depth',
                dView: true
            }, {
                title: 'File Name',
                select: 'filename',
                dView: true
            }, {
                title: 'Domain',
                select: 'top_domain',
                dView: true
            }, {
                title: 'Subdomain',
                select: 'host',
                dView: true
            }, {
                title: 'Tags',
                select: 'tags',
                dView: true
            }, {
                title: 'URI',
                select: 'uri',
                dView: true
            }, {
                title: 'URL',
                select: 'url',
                dView: true
            }, {
                title: 'Request Body Length',
                select: 'request_body_len',
                dView: true
            }, {
                title: 'Response Body Length',
                select: 'response_body_len',
                dView: true
            }, {
                title: 'Method',
                select: 'method',
                dView: true
            }, {
                title: 'Proxied',
                select: 'proxied',
                dView: false
            }, {
                title: 'Proxy Rule',
                select: 'proxy_rule',
                dView: false
            }, {
                title: 'Referrer',
                select: 'referrer',
                dView: true
            }, {
                title: 'Status Code',
                select: 'status_code',
                dView: true
            }, {
                title: 'Status Message',
                select: 'status_msg',
                dView: true
            }, {
                title: 'User Agent',
                select: 'user_agent',
                dView: true
            }, {
                title: 'Info Code',
                select: 'info_code',
                dView: true
            }, {
                title: 'Info Message',
                select: 'info_msg',
                dView: true
            }, {
                title: 'IOC Class',
                select: 'ioc_class',
                dView: true
            }, {
                title: 'IOC Confidence',
                select: 'ioc_confidence',
                dView: true
            }, {
                title: 'IOC Count',
                select: 'ioc_count',
                dView: true
            }, {
                title: 'IOC ID',
                select: 'ioc_id',
                dView: true
            }, {
                title: 'IOC Rule',
                select: 'ioc_rule',
                dView: true
            }, {
                title: 'IOC Severity',
                select: 'ioc_severity',
                dView: true
            }, {
                title: 'IOC Stage',
                select: 'ioc_stage',
                dView: true
            }, {
                title: 'IOC Type',
                select: 'ioc_type',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'conn_uid': 'Connection UID',
                'depth': 'Depth',
                'filename': 'File Name',
                'top_domain': 'Domain',
                'host': 'Subdomain',
                'info_code': 'Info Code',
                'info_msg': 'Info Message',
                'ioc_class': 'IOC Class',
                // 'ioc_count' : "IOC Count",
                'ioc_id': 'IOC ID',
                'ioc_severity': 'IOC Severity',
                'ioc_rule': 'IOC Rules',
                'ioc_stage': 'IOC Stage',
                'ioc_type': 'IOC Type',
                'orig_hostname': 'Orig Hostname',
                'orig_port': 'Orig Port',
                'orig_user': 'Orig User',
                'method': 'Method',
                'referrer': 'Referrer',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
                'status_code': 'Status Code',
                'status_msg': 'Status Message',
                'tags': 'Tags',
                'uri': 'URI',
                'url': 'URL',
                'user_agent': 'User Agent',
            },
            title: 'HTTP',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        intel: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Cyrin Class',
                select: 'cyrin_class',
                dView: true
            }, {
                title: 'Cyrin Confidence',
                select: 'cyrin_confidence',
                dView: true
            }, {
                title: 'Cyrin ID',
                select: 'cyrin_id',
                dView: true
            }, {
                title: 'Cyrin Severity',
                select: 'cyrin_severity',
                dView: true
            }, {
                title: 'File Description',
                select: 'file_desc',
                dView: true
            }, {
                title: 'File MIME Type',
                select: 'file_mime_type',
                dView: true
            }, {
                title: 'File UID',
                select: 'fuid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Local',
                select: 'orig_local',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Local',
                select: 'resp_local',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Seen Indicator',
                select: 'seen_indicator',
                dView: true
            }, {
                title: 'Seen Indicator Type',
                select: 'seen_indicator_type',
                dView: true
            }, {
                title: 'Seen Node',
                select: 'seen_node',
                dView: true
            }, {
                title: 'Seen Where',
                select: 'seen_where',
                dView: true
            }, {
                title: 'Sources',
                select: 'sources',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'time': 'Time',
                'conn_uid': 'Connection UID',
                'cyrin_class': 'Cyrin Class',
                'cyrin_confidence': 'Cyrin Confidence',
                'cyrin_id': 'Cyrin ID',
                'cyrin_severity': 'Cyrin Severity',
                'file_desc': 'File Description',
                'file_mime_type': 'File MIME Type',
                'fuid': 'File UID',
                'orig_ip': 'Orig IP',
                'orig_local': 'Orig Local',
                'orig_port': 'Orig Port',
                'resp_ip': 'Resp IP',
                'resp_local': 'Resp Local',
                'resp_port': 'Resp Port',
                'seen_indicator': 'Seen Indicator',
                'seen_indicator_type': 'Seen Indicator Type',
                'seen_node': 'Seen Node',
                'seen_where': 'Seen Where',
                'sensor': 'Sensor',
                'sources': 'Sources',
            },
            title: 'Intel',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        irc: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, {
                title: 'User',
                select: 'user',
                dView: true
            }, {
                title: 'Nick',
                select: 'nick',
                dView: true
            }, {
                title: 'Command',
                select: 'command',
                dView: true
            }, {
                title: 'Value',
                select: 'value',
                dView: true
            }, {
                title: 'DCC File Name',
                select: 'dcc_file_name',
                dView: true
            }, {
                title: 'DCC File Size',
                select: 'dcc_file_size',
                dView: true
            }, {
                title: 'DCC MIME Type',
                select: 'dcc_mime_type',
                dView: true
            }, {
                title: 'File UID',
                select: 'fuid',
                dView: true
            }, {
                title: 'Additional Data',
                select: 'addl',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'addl': 'Additional Data',
                'command': 'Command',
                'conn_uid': 'Connection UID',
                'dcc_file_name': 'DCC File Name',
                'dcc_file_size': 'DCC File Size',
                'dcc_mime_type': 'DCC MIME Type',
                'fuid': 'File UID',
                'orig_hostname': 'Orig Hostname',
                'orig_port': 'Orig Port',
                'orig_user': 'Orig User',
                'nick': 'Nick',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
                'user': 'User',
                'value': 'Value',
            },
            title: 'IRC',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        kerberos: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Request Type',
                select: 'request_type',
                dView: true
            }, {
                title: 'Client',
                select: 'client',
                dView: true
            }, {
                title: 'Service',
                select: 'service',
                dView: true
            }, {
                title: 'Success',
                select: 'success',
                dView: true
            }, {
                title: 'Error Msg',
                select: 'error_msg',
                dView: true
            }, {
                title: 'From',
                select: 'from',
                dView: true
            }, {
                title: 'Till',
                select: 'till',
                dView: true
            }, {
                title: 'Cipher',
                select: 'cipher',
                dView: true
            }, {
                title: 'Forwardable',
                select: 'forwardable',
                dView: true
            }, {
                title: 'Renewable',
                select: 'renewable',
                dView: true
            }, {
                title: 'Client Cert FUID',
                select: 'client_cert_fuid',
                dView: true
            }, {
                title: 'Client Cert Subject',
                select: 'client_cert_subject',
                dView: true
            }, {
                title: 'Server Cert FUID',
                select: 'server_cert_fuid',
                dView: true
            }, {
                title: 'Server Cert Subject',
                select: 'server_cert_subject',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'time': 'Time',
                'conn_uid': 'Connection UID',
                'orig_ip': 'Orig IP',
                'orig_port': 'Orig Port',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'request_type': 'Request Type',
                'client': 'Client',
                'service': 'Service',
                'success': 'Success',
                'error_msg': 'Error Msg',
                'from': 'From',
                'till': 'Till',
                'cipher': 'Cipher',
                'forwardable': 'Forwardable',
                'renewable': 'Renewable',
                'client_cert_fuid': 'Client Cert FUID',
                'client_cert_subject': 'Client Cert Subject',
                'server_cert_fuid': 'Server Cert FUID',
                'server_cert_subject': 'Server Cert Subject',
                'sensor': 'Sensor',
            },
            title: 'Kerberos',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        known_services: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Service',
                select: 'service',
                dView: true
            }, {
                title: 'Host',
                select: 'host',
                dView: true
            }, {
                title: 'Port Number',
                select: 'port_num',
                dView: true
            }, {
                title: 'Port Protocol',
                select: 'port_proto',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'time': 'Time',
                'host': 'Host',
                'port_num': 'Port Number',
                'port_proto': 'Port Protocol',
                'sensor': 'Sensor',
                'service': 'Service',
            },
            title: 'Known Services',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        known_certs: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Host',
                select: 'host',
                dView: true
            }, {
                title: 'Issuer Subject',
                select: 'issuer_subject',
                dView: true
            }, {
                title: 'Port Number',
                select: 'port_num',
                dView: true
            }, {
                title: 'Serial',
                select: 'serial',
                dView: true
            }, {
                title: 'Subject',
                select: 'subject',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'time': 'Time',
                'host': 'Host',
                'issuer_subject': 'Issuer Subject',
                'port_num': 'Port Number',
                'serial': 'Serial',
                'subject': 'Subject',
                'sensor': 'Sensor',
            },
            title: 'Known Certs',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        mysql: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Argument',
                select: 'arg',
                dView: true
            }, {
                title: 'Command',
                select: 'cmd',
                dView: true
            }, {
                title: 'Response',
                select: 'response',
                dView: true
            }, {
                title: 'Rows',
                select: 'rows',
                dView: true
            }, {
                title: 'Success',
                select: 'success',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'arg': 'Argument',
                'cmd': 'Command',
                'conn_uid': 'Connection UID',
                'orig_port': 'Orig Port',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'response': 'Response',
                'rows': 'Rows',
                'sensor': 'Sensor',
                'success': 'Success',
            },
            title: 'MySQL',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        modbus: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'uid',
                dView: true
            },  {
                title: 'Func',
                select: 'func',
                dView: true
            }, {
                title: 'Exception',
                select: 'exception',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'id_orig_h',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'id_orig_p',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'id_resp_h',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'id_resp_p',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            },],
            searchCategories: {
                'func': 'Func',
                'exception': 'Exception',
                'id_orig_h': 'Orig IP',
                'time': 'Time',
                'orig_hostname': 'Orig Hostname',
                'id_orig_p': 'Orig Port',
                'orig_user': 'Orig User',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'id_resp_h': 'Resp IP',
                'id_resp_p': 'Resp Port',
            },
            title: 'Modbus',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        notice: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Actions',
                select: 'actions',
                dView: true
            }, {
                title: 'Dropped',
                select: 'dropped',
                dView: true
            }, {
                title: 'Destination',
                select: 'dst',
                dView: true
            }, {
                title: 'File Description',
                select: 'file_desc',
                dView: true
            }, {
                title: 'File MIME Type',
                select: 'file_mime_type',
                dView: true
            }, {
                title: 'File UID',
                select: 'fuid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Message',
                select: 'msg',
                dView: true
            }, {
                title: 'N',
                select: 'n',
                dView: true
            }, {
                title: 'Note',
                select: 'note',
                dView: true
            }, {
                title: 'P',
                select: 'p',
                dView: true
            }, {
                title: 'Peer Description',
                select: 'peer_descr',
                dView: true
            }, {
                title: 'Protocol',
                select: 'proto',
                dView: true
            }, {
                title: 'Resp Location City',
                select: 'resp_location_city',
                dView: true
            }, {
                title: 'Resp Location Country Code',
                select: 'resp_location_country_code',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, {
                title: 'Source',
                select: 'src',
                dView: true
            }, {
                title: 'Sub',
                select: 'sub',
                dView: true
            }, {
                title: 'Suppress For',
                select: 'suppress_for',
                dView: true
            }, ],
            searchCategories: {
                'time': 'Time',
                'actions': 'Actions',
                'conn_uid': 'Connection UID',
                'dropped': 'Dropped',
                'file_desc': 'File Description',
                'file_mime_type': 'File MIME Type',
                'fuid': 'File UID',
                'orig_ip': 'ID Orig IP',
                'orig_port': 'ID Orig Port',
                'resp_ip': 'ID Resp IP',
                'resp_port': 'ID Resp Port',
                'msg': 'Message',
                'n': 'N',
                'note': 'Note',
                'p': 'P',
                'peer_descr': 'Peer Description',
                'proto': 'Protocol',
                'resp_location_city': 'Resp Location City',
                'resp_location_country_code': 'Resp Location Country Code',
                'sensor': 'Sensor',
                'src': 'Source',
                'sub': 'Sub',
                'suppress_for': 'Suppress For',
            },
            title: 'Notice',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        pe: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Compile Time',
                select: 'compile_ts',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Cert Table',
                select: 'has_cert_table',
                dView: true
            }, {
                title: 'Debug Data',
                select: 'has_debug_data',
                dView: true
            }, {
                title: 'Export Table',
                select: 'has_export_table',
                dView: true
            }, {
                title: 'Import Table',
                select: 'has_import_table',
                dView: true
            }, {
                title: 'Is 64-bit',
                select: 'is_64bit',
                dView: true
            }, {
                title: 'Is exe',
                select: 'is_exe',
                dView: true
            }, {
                title: 'Machine',
                select: 'machine',
                dView: true
            }, {
                title: 'OS',
                select: 'os',
                dView: true
            }, {
                title: 'Section Names',
                select: 'section_names',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, {
                title: 'Sub System',
                select: 'subsystem',
                dView: true
            }, {
                title: 'ASLR',
                select: 'uses_aslr',
                dView: true
            }, {
                title: 'Code Integrity',
                select: 'uses_code_integrity',
                dView: true
            }, {
                title: 'Dep',
                select: 'uses_dep',
                dView: true
            }, {
                title: 'Seh',
                select: 'uses_seh',
                dView: true
            }, ],
            searchCategories: {
                'time': 'Time',
                'compile_ts': 'Compile Time',
                'conn_uid': 'Connection UID',
                'has_cert_table': 'Cert Table',
                'has_debug_data': 'Debug Data',
                'has_export_table': 'Export Table',
                'has_import_table': 'Import Table',
                'is_64bit': 'Is 64-bit',
                'is_exe': 'Is exe',
                'machine': 'Machine',
                'os': 'OS',
                'section_names': 'Section Names',
                'sensor': 'Sensor',
                'subsystem': 'Sub System',
                'uses_aslr': 'ASLR',
                'uses_code_integrity': 'Code Integrity',
                'uses_dep': 'Dep',
                'uses_seh': 'Seh',
            },
            title: 'RDP',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        profinet: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'uid',
                dView: true
            }, {
                title: 'Operation Type',
                select: 'operation_type',
                dView: true
            }, {
                title: 'Block Version',
                select: 'block_version',
                dView: true
            }, {
                title: 'Slot Number',
                select: 'slot_number',
                dView: true
            }, {
                title: 'Subslot Number',
                select: 'subslot_number',
                dView: true
            }, {
                title: 'Index',
                select: 'index',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'id_orig_h',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'id_orig_p',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'id_resp_h',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'id_resp_p',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, ],
            searchCategories: {
                'operation_type': 'Operation Type',
                'block_version': 'Block Version',
                'index': 'Index',
                'id_orig_h': 'Orig IP',
                'time': 'Time',
                'orig_hostname': 'Orig Hostname',
                'id_orig_p': 'Orig Port',
                'orig_user': 'Orig User',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'id_resp_h': 'Resp IP',
                'id_resp_p': 'Resp Port',
            },
            title: 'Profinet',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        rdp: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Cert Count',
                select: 'cert_count',
                dView: true
            }, {
                title: 'Cert Permanent',
                select: 'cert_permanent',
                dView: true
            }, {
                title: 'Cert Type',
                select: 'cert_type',
                dView: true
            }, {
                title: 'Client Build',
                select: 'client_build',
                dView: true
            }, {
                title: 'Client Dig Product ID',
                select: 'client_dig_product_id',
                dView: true
            }, {
                title: 'Client Name',
                select: 'client_name',
                dView: true
            }, {
                title: 'Cookie',
                select: 'cookie',
                dView: true
            }, {
                title: 'Desktop Height',
                select: 'desktop_height',
                dView: true
            }, {
                title: 'Desktop Width',
                select: 'desktop_width',
                dView: true
            }, {
                title: 'Encryption Level',
                select: 'encryption_level',
                dView: true
            }, {
                title: 'Encryption Method',
                select: 'encryption_method',
                dView: true
            }, {
                title: 'Keyboard Layout',
                select: 'keyboard_layout',
                dView: true
            }, {
                title: 'Requesed Color Depth',
                select: 'requested_color_depth',
                dView: true
            }, {
                title: 'Result',
                select: 'result',
                dView: true
            }, {
                title: 'Security Protocol',
                select: 'security_protocol',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'cert_count': 'Cert Count',
                'cert_permanent': 'Cert Permanent',
                'cert_type': 'Cert Type',
                'client_build': 'Client Build',
                'client_dig_product_id': 'Client Dig Product ID',
                'client_name': 'Client Name',
                'conn_uid': 'Connection UID',
                'cookie': 'Cookie',
                'desktop_height': 'Desktop Height',
                'desktop_width': 'Desktop Width',
                'encryption_level': 'Encryption Level',
                'encryption_method': 'Encryption Method',
                'keyboard_layout': 'Keyboard Layout',
                'orig_port': 'Orig Port',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'requested_color_depth': 'Requesed Color Depth',
                'result': 'Result',
                'security_protocol': 'Security Protocol',
                'sensor': 'Sensor',
            },
            title: 'RDP',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        sip: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Call ID',
                select: 'call_id',
                dView: true
            }, {
                title: 'Content Type',
                select: 'content_type',
                dView: true
            }, {
                title: 'Date',
                select: 'date',
                dView: true
            }, {
                title: 'Method',
                select: 'method',
                dView: true
            }, {
                title: 'Sequence',
                select: 'seq',
                dView: true
            }, {
                title: 'Status Code',
                select: 'status_code',
                dView: true
            }, {
                title: 'Status Message',
                select: 'status_msg',
                dView: true
            }, {
                title: 'Subject',
                select: 'subject',
                dView: true
            }, {
                title: 'Trans Depth',
                select: 'trans_depth',
                dView: true
            }, {
                title: 'URI',
                select: 'uri',
                dView: true
            }, {
                title: 'Warning',
                select: 'warning',
                dView: true
            }, {
                title: 'Reply To',
                select: 'reply_to',
                dView: true
            }, {
                title: 'Request Body Length',
                select: 'request_body_len',
                dView: true
            }, {
                title: 'Request From',
                select: 'request_from',
                dView: true
            }, {
                title: 'Request Path',
                select: 'request_path',
                dView: true
            }, {
                title: 'Request To',
                select: 'request_to',
                dView: true
            }, {
                title: 'Response Body Length',
                select: 'response_body_len',
                dView: true
            }, {
                title: 'Response From',
                select: 'response_from',
                dView: true
            }, {
                title: 'Response Path',
                select: 'response_path',
                dView: true
            }, {
                title: 'Response To',
                select: 'response_to',
                dView: true
            }, {
                title: 'User Agent',
                select: 'user_agent',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'time': 'Time',
                'call_id': 'Call ID',
                'content_type': 'Content Type',
                'date': 'Date',
                'method': 'Method',
                'seq': 'Sequence',
                'status_code': 'Status Code',
                'status_msg': 'Status Message',
                'subject': 'Subject',
                'trans_depth': 'Trans Depth',
                'uri': 'URI',
                'warning': 'Warning',
                'orig_ip': 'Orig IP',
                'orig_port': 'Orig Port',
                'reply_to': 'Reply To',
                'request_body_len': 'Request Body Length',
                'request_from': 'Request From',
                'request_path': 'Request Path',
                'request_to': 'Request To',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'response_body_len': 'Response Body Length',
                'response_from': 'Response From',
                'response_path': 'Response Path',
                'response_to': 'Response To',
                'user_agent': 'User Agent',
                'sensor': 'Sensor',
                'conn_uid': 'Connection UID',

            },
            title: 'SIP',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        snmp: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Community',
                select: 'community',
                dView: true
            }, {
                title: 'Display String',
                select: 'display_string',
                dView: true
            }, {
                title: 'Duration',
                select: 'duration',
                dView: true
            }, {
                title: 'Get Bulk Requests',
                select: 'get_bulk_requests',
                dView: true
            }, {
                title: 'Get Requests',
                select: 'get_requests',
                dView: true
            }, {
                title: 'Get Responses',
                select: 'get_responses',
                dView: true
            }, {
                title: 'Set Requests',
                select: 'set_requests',
                dView: true
            }, {
                title: 'Up Since',
                select: 'up_since',
                dView: true
            }, {
                title: 'Version',
                select: 'version',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'community': 'Community',
                'conn_uid': 'Connection UID',
                'display_string': 'Display String',
                'duration': 'Duration',
                'get_bulk_requests': 'Get Bulk Requests',
                'get_requests': 'Get Requests',
                'get_responses': 'Get Responses',
                'orig_port': 'Orig Port',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
                'set_requests': 'Set Requests',
                'up_since': 'Up Since',
                'version': 'Version',
            },
            title: 'SNMP',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        smtp: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, {
                title: 'SMTP From',
                select: 'smtp_from',
                dView: true
            }, {
                title: 'SMTP To',
                select: 'smtp_to',
                dView: true
            }, {
                title: 'Subject',
                select: 'subject',
                dView: true
            }, {
                title: 'TLS',
                select: 'tls',
                dView: true
            }, {
                title: 'Trans Depth',
                select: 'trans_depth',
                dView: true
            }, {
                title: 'User Agent',
                select: 'user_agent',
                dView: true
            }, {
                title: 'Date',
                select: 'date',
                dView: true
            }, {
                title: 'First Received',
                select: 'first_rcvd',
                dView: true
            }, {
                title: 'File UIDs',
                select: 'fuids',
                dView: true
            }, {
                title: 'Helo Header',
                select: 'helo',
                dView: true
            }, {
                title: 'In Reply To',
                select: 'in_reply_to',
                dView: true
            }, {
                title: 'Info Code',
                select: 'info_code',
                dView: true
            }, {
                title: 'Info Message',
                select: 'info_msg',
                dView: true
            }, {
                title: 'Is Webmail',
                select: 'is_webmail',
                dView: true
            }, {
                title: 'Second Received',
                select: 'second_rcvd',
                dView: true
            }, {
                title: 'Reply To',
                select: 'reply_to',
                dView: true
            }, {
                title: 'Mail From',
                select: 'mailfrom',
                dView: true
            }, {
                title: 'Message ID',
                select: 'msg_id',
                dView: true
            }, {
                title: 'Originating IP Header',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Path',
                select: 'path',
                dView: true
            }, {
                title: 'Receipt To',
                select: 'receiptto',
                dView: true
            }, {
                title: 'Last Reply',
                select: 'last_reply',
                dView: true
            }, {
                title: 'IOC Class',
                select: 'ioc_class',
                dView: true
            }, {
                title: 'IOC Confidence',
                select: 'ioc_confidence',
                dView: true
            }, {
                title: 'IOC Count',
                select: 'ioc_count',
                dView: true
            }, {
                title: 'IOC ID',
                select: 'ioc_id',
                dView: true
            }, {
                title: 'IOC Rule',
                select: 'ioc_rule',
                dView: true
            }, {
                title: 'IOC Severity',
                select: 'ioc_severity',
                dView: true
            }, {
                title: 'IOC Stage',
                select: 'ioc_stage',
                dView: true
            }, {
                title: 'IOC Type',
                select: 'ioc_type',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'conn_uid': 'Connection UID',
                'date': 'Date',
                'first_rcvd': 'First Received',
                'fuids': 'File UIDs',
                'helo': 'Helo Header',
                'in_reply_to': 'In Reply To',
                'ioc_class': 'IOC Class',
                // 'ioc_count' : "IOC Count",
                'ioc_id': 'IOC ID',
                'ioc_severity': 'IOC Severity',
                'ioc_rule': 'IOC Rules',
                'ioc_stage': 'IOC Stage',
                'ioc_type': 'IOC Type',
                'is_webmail': 'Is Webmail',
                'last_reply': 'Last Reply',
                'orig_hostname': 'Orig Hostname',
                'orig_port': 'Orig Port',
                'orig_user': 'Orig User',
                'mailfrom': 'Mail From',
                'msg_id': 'Message ID',
                'orig_ip': 'Originating IP Header',
                'path': 'Path',
                'receiptto': 'Receipt To',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'reply_to': 'Reply To',
                'second_rcvd': 'Second Received',
                'sensor': 'Sensor',
                'smtp_from': 'SMTP From',
                'smtp_to': 'SMTP To',
                'subject': 'Subject',
                'tls': 'TLS',
                'trans_depth': 'Trans Depth',
                'user_agent': 'User Agent',
            },
            title: 'SMTP',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        ssh: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, {
                title: 'Authentication Success',
                select: 'auth_success',
                dView: true
            }, {
                title: 'Cipher Algorithm',
                select: 'cipher_alg',
                dView: true
            }, {
                title: 'Client',
                select: 'client',
                dView: true
            }, {
                title: 'Compression Algorithm',
                select: 'compression_alg',
                dView: true
            }, {
                title: 'Direction',
                select: 'direction',
                dView: true
            }, {
                title: 'Host Key',
                select: 'host_key',
                dView: true
            }, {
                title: 'Host Key Algorithm',
                select: 'host_key_alg',
                dView: true
            }, {
                title: 'MAC Algorithm',
                select: 'mac_alg',
                dView: true
            }, {
                title: 'Server',
                select: 'server',
                dView: true
            }, {
                title: 'Status',
                select: 'status',
                dView: true
            }, {
                title: 'Version',
                select: 'version',
                dView: true
            }, {
                title: 'Key Exchange Algorithm',
                select: 'kex_alg',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'auth_success': 'Authentication Success',
                'cipher_alg': 'Cipher Algorithm',
                'client': 'Client',
                'compression_alg': 'Compression Algorithm',
                'conn_uid': 'Connection UID',
                'direction': 'Direction',
                'host_key': 'Host Key',
                'host_key_alg': 'Host Key Algorithm',
                'kex_alg': 'Key Exchange Algorithm',
                'orig_hostname': 'Orig Hostname',
                'orig_port': 'Orig Port',
                'orig_user': 'Orig User',
                'mac_alg': 'MAC Algorithm',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
                'server': 'Server',
                'status': 'Status',
                'version': 'Version',
            },
            title: 'SSH',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        ssl: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'JA3',
                select: 'ja3',
                dView: true
            }, {
                title: 'JA3s',
                select: 'ja3s',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, {
                title: 'Top Level Server Name',
                select: 'top_server',
                dView: true
            }, {
                title: 'Server Name',
                select: 'server_name',
                dView: true
            }, {
                title: 'Subject',
                select: 'subject',
                dView: true
            }, {
                title: 'Cipher',
                select: 'cipher',
                dView: true
            }, {
                title: 'Issuer',
                select: 'issuer',
                dView: true
            }, {
                title: 'Client Issuer',
                select: 'client_issuer',
                dView: true
            }, {
                title: 'Client Subject',
                select: 'client_subject',
                dView: true
            }, {
                title: 'Curve',
                select: 'curve',
                dView: true
            }, {
                title: 'Resumed',
                select: 'resumed',
                dView: true
            }, {
                title: 'Next Protocol',
                select: 'next_protocol',
                dView: true
            }, {
                title: 'Established',
                select: 'established',
                dView: true
            }, {
                title: 'Cert Chain File UIDs',
                select: 'cert_chain_fuids',
                dView: true
            }, {
                title: 'Client Cert Chain File UIDs',
                select: 'client_cert_chain_fuids',
                dView: true
            }, {
                title: 'Validation Status',
                select: 'validation_status',
                dView: true
            }, {
                title: 'Notary First Seen',
                select: 'notary_first_seen',
                dView: true
            }, {
                title: 'Notary Last Seen',
                select: 'notary_last_seen',
                dView: true
            }, {
                title: 'Notary Times Seen',
                select: 'notary_times_seen',
                dView: true
            }, {
                title: 'Notary Valid',
                select: 'notary_valid',
                dView: true
            }, {
                title: 'Version',
                select: 'version',
                dView: true
            }, {
                title: 'Proxy Rule',
                select: 'proxy_rule',
                dView: true
            }, {
                title: 'Last Alert',
                select: 'last_alert',
                dView: true
            }, {
                title: 'IOC Class',
                select: 'ioc_class',
                dView: true
            }, {
                title: 'IOC Confidence',
                select: 'ioc_confidence',
                dView: true
            }, {
                title: 'IOC Count',
                select: 'ioc_count',
                dView: true
            }, {
                title: 'IOC ID',
                select: 'ioc_id',
                dView: true
            }, {
                title: 'IOC Rule',
                select: 'ioc_rule',
                dView: true
            }, {
                title: 'IOC Severity',
                select: 'ioc_severity',
                dView: true
            }, {
                title: 'IOC Stage',
                select: 'ioc_stage',
                dView: true
            }, {
                title: 'IOC Type',
                select: 'ioc_type',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'cipher': 'Cipher',
                'client_subject': 'Client Subject',
                'conn_uid': 'Connection UID',
                'ioc_class': 'IOC Class',
                // 'ioc_count' : "IOC Count",
                'ioc_id': 'IOC ID',
                'ioc_severity': 'IOC Severity',
                'ioc_rule': 'IOC Rules',
                'ioc_stage': 'IOC Stage',
                'ioc_type': 'IOC Type',
                'last_alert': 'Last Alert',
                'orig_hostname': 'Orig Hostname',
                'orig_port': 'Orig Port',
                'orig_user': 'Orig User',
                'proxy_rule': 'Proxy Rule',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
                'top_server': 'Top Level Server Name',
                'server_name': 'Server Name',
                'session_id': 'Session ID',
                'subject': 'Subject',
                'version': 'Version',
                'curve': 'Curve',
                'issuer': 'Issuer',
                'resumed': 'Resumed',
                'next_protocol': 'Next Protocol',
                'established': 'Established',
                'cert_chain_fuids': 'Cert Chain File UIDs',
                'client_cert_chain_fuids': 'Client Cert Chain File UIDs',
                'client_issuer': 'Client Issuer',
                'validation_status': 'Validation Status',
                'notary_first_seen': 'Notary First Seen',
                'notary_last_seen': 'Notary Last Seen',
                'notary_times_seen': 'Notary Times Seen',
                'notary_valid': 'Notary Valid',
                'ja3': 'JA3',
                'ja3s':'JA3s'
            },
            title: 'SSL',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        syslog: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Protocol',
                select: 'proto',
                dView: true
            }, {
                title: 'Severity',
                select: 'severity',
                dView: true
            }, {
                title: 'Facility',
                select: 'facility',
                dView: true
            }, {
                title: 'Message',
                select: 'message',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'conn_uid': 'Connection UID',
                'facility': 'Facility',
                'orig_port': 'Orig Port',
                'message': 'Message',
                'proto': 'Resp Port',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
                'severity': 'Severity',
            },
            title: 'Syslog',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        s7comm: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'uid',
                dView: true
            }, {
                title: 'Rosctr',
                select: 'rosctr',
                dView: true
            }, {
                title: 'Parameter',
                select: 'parameter',
                dView: true
            }, {
                title: 'Item Count',
                select: 'item_count',
                dView: true
            }, {
                title: 'Data Info',
                select: 'data_info',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'id_orig_h',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'id_orig_p',
                dView: true
            }, {
                title: 'Orig User',
                select: 'orig_user',
                dView: true
            }, {
                title: 'Orig Hostname',
                select: 'orig_hostname',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'id_resp_h',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'id_resp_p',
                dView: true
            }, {
                title: 'Resp ASN Name',
                select: 'resp_asn_name',
                dView: true
            }, {
                title: 'Resp Flag',
                select: 'resp_cc',
                dView: true
            }, {
                title: 'Resp City',
                select: 'resp_city',
                dView: true
            }, {
                title: 'Resp Country',
                select: 'resp_country',
                dView: true
            }, {
                title: 'Resp Hostname',
                select: 'resp_hostname',
                dView: true
            }, ],
            searchCategories: {
                'rosctr': 'Rosctr',
                'parameter': 'Parameter',
                'data_info': 'Data Info',
                'id_orig_h': 'Orig IP',
                'time': 'Time',
                'orig_hostname': 'Orig Hostname',
                'id_orig_p': 'Orig Port',
                'orig_user': 'Orig User',
                'resp_asn_name': 'Resp ASN Name',
                'resp_cc': 'Resp Flag',
                'resp_city': 'Resp City',
                'resp_country': 'Resp Country',
                'resp_hostname': 'Resp Hostname',
                'id_resp_h': 'Resp IP',
                'id_resp_p': 'Resp Port',
            },
            title: 'S7comm',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        traceroute: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Protocol',
                select: 'proto',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'proto': 'Resp Port',
                'resp_ip': 'Resp IP',
                'sensor': 'Sensor',
            },
            title: 'Traceroute',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        tunnel: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Action',
                select: 'action',
                dView: true
            }, {
                title: 'Tunnel Type',
                select: 'tunnel_type',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'action': 'Action',
                'conn_uid': 'Connection UID',
                'orig_port': 'Orig Port',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
                'tunnel_type': 'Tunnel Type',
            },
            title: 'Tunnel',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        weird: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'Connection UID',
                select: 'conn_uid',
                dView: true
            }, {
                title: 'Orig IP',
                select: 'orig_ip',
                dView: true
            }, {
                title: 'Orig Port',
                select: 'orig_port',
                dView: true
            }, {
                title: 'Resp IP',
                select: 'resp_ip',
                dView: true
            }, {
                title: 'Resp Port',
                select: 'resp_port',
                dView: true
            }, {
                title: 'Name',
                select: 'name',
                dView: true
            }, {
                title: 'Notice',
                select: 'notice',
                dView: true
            }, {
                title: 'Peer',
                select: 'peer',
                dView: true
            }, {
                title: 'Additional Data',
                select: 'addl',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'vector': 'Vector',
                'orig_ip': 'Orig IP',
                'time': 'Time',
                'addl': 'Additional Data',
                'conn_uid': 'Connection UID',
                'orig_port': 'Orig Port',
                'name': 'Name',
                'notice': 'Notice',
                'peer': 'Peer',
                'resp_ip': 'Resp IP',
                'resp_port': 'Resp Port',
                'sensor': 'Sensor',
            },
            title: 'Weird',
            sort: {
                direction: '-',
                col: 'time'
            }
        },
        x509: {
            columns: [{
                title: 'Time',
                select: 'time',
                dView: true
            }, {
                title: 'File UID',
                select: 'fuid',
                dView: true
            }, {
                title: 'Basic Constraints CA',
                select: 'basic_constraints_ca',
                dView: true
            }, {
                title: 'Basic Constraints Path Length',
                select: 'basic_constraints_path_len',
                dView: true
            }, {
                title: 'Certificate Curve',
                select: 'certificate_curve',
                dView: true
            }, {
                title: 'Certificate Exponent',
                select: 'certificate_exponent',
                dView: true
            }, {
                title: 'Certificate Issuer',
                select: 'certificate_issuer',
                dView: true
            }, {
                title: 'Certificate Key Algorithm',
                select: 'certificate_key_alg',
                dView: true
            }, {
                title: 'Certificate Key Length',
                select: 'certificate_key_length',
                dView: true
            }, {
                title: 'Certificate Key Type',
                select: 'certificate_key_type',
                dView: true
            }, {
                title: 'Certificate Not Valid After',
                select: 'certificate_not_valid_after',
                dView: true
            }, {
                title: 'Certificate Not Valid Before',
                select: 'certificate_not_valid_before',
                dView: true
            }, {
                title: 'Certificate Serial',
                select: 'certificate_serial',
                dView: true
            }, {
                title: 'Certificate Signiture Algorithm',
                select: 'certificate_sig_alg',
                dView: true
            }, {
                title: 'Certificate Subject',
                select: 'certificate_subject',
                dView: true
            }, {
                title: 'Certificate Version',
                select: 'certificate_version',
                dView: true
            }, {
                title: 'SAN DNS',
                select: 'san_dns',
                dView: true
            }, {
                title: 'SAN Email',
                select: 'san_email',
                dView: true
            }, {
                title: 'SAN IP',
                select: 'san_ip',
                dView: true
            }, {
                title: 'SAN URI',
                select: 'san_uri',
                dView: true
            }, {
                title: 'Sensor',
                select: 'sensor',
                dView: true
            }, ],
            searchCategories: {
                'time': 'Time',
                'basic_constraints_ca': 'Basic Constraints CA',
                'basic_constraints_path_len': 'Basic Constraints Path Length',
                'certificate_curve': 'Certificate Curve',
                'certificate_exponent': 'Certificate Exponent',
                'certificate_issuer': 'Certificate Issuer',
                'certificate_key_alg': 'Certificate Key Algorithm',
                'certificate_key_length': 'Certificate Key length',
                'certificate_key_type': 'Certificate Key Type',
                'certificate_not_valid_after': 'Certificate Not Valid After',
                'certificate_not_valid_before': 'Certificate Not Valid Before',
                'certificate_serial': 'Certificate Serial',
                'certificate_sig_alg': 'Certificate Signiture Algorithm',
                'certificate_subject': 'Certificate Subject',
                'certificate_version': 'Certificate Version',
                'fuid': 'File UID`',
                'san_dns': 'SAN DNS',
                'san_email': 'SAN Email',
                'san_ip': 'SAN IP',
                'san_uri': 'SAN URI',
                'sensor': 'Sensor',
            },
            title: 'x509',
            sort: {
                direction: '-',
                col: 'time'
            }
        }
    }
    // set inital mode
    $scope.main.currentMode = 'conn';
    // set inital reqId value
    $scope.main.manualSearchId = generateId();

    // set devault killchain variable when first land on page
    let killChain = {
        'include': [],
        'exclude': []
    };
    // if 'include' exists in the state params, push it tot the killchain
    if ($stateParams.include) {
        killChain.include = $stateParams.include.map(function(d) {
            let obj = {}
            obj[d.from] = d.value;
            return obj;
        })
    }
    // if 'exclude' exists in the state params, push it tot the killchain
    if ($stateParams.exclude) {
        killChain.exclude = $stateParams.exclude.map(function(d) {
            let obj = {}
            obj[d.from] = d.value;
            return obj;
        })
    }
    // set the mode if the incomming is defined
    if ($stateParams.mode) {
        $scope.main.currentMode = $stateParams.mode;
    }

    let paramsSanitize = function(params, mode) {
        let modeRelevantParams = {
                include: [],
                exclude: []
            },
            isAll = false;
        // included items
        let ilen = params.include.length;
        if (ilen > 0) {
            for (let i = 0; i < ilen; i++) {
                let keys = Object.keys(params.include[i]);
                let key = keys[0];
                if (tableSettings[mode].searchCategories.hasOwnProperty(key) || (key === 'all')) {
                    let item = {}
                    item[key] = params.include[i][key];
                    modeRelevantParams.include.push(item);
                }
                // set all mode if a an item in 'all' exists
                if (key === 'all') {
                    isAll = true;
                }
            }
        }
        // excluded items
        let elen = params.exclude.length;
        if (elen > 0) {
            for (let i = 0; i < elen; i++) {
                let keys = Object.keys(params.exclude[i]);
                let key = keys[0];
                if (tableSettings[mode].searchCategories.hasOwnProperty(key) || (key === 'all')) {
                    let item = {}
                    item[key] = params.exclude[i][key];
                    modeRelevantParams.exclude.push(item);
                }
                // set all mode if a an item in 'all' exists
                if (key === 'all') {
                    isAll = true;
                }
            }
        }
        // 'ALL' SEARCH
        if (isAll) {
            // if there are 'all' params, loop through searchCategories and generate an array of columns
            isAll = [];
            let dontSearch = ['time', 'ioc_severity', 'session_id', 'notary_valid']; // these dont have mappers yet
            for (let f in tableSettings[mode].searchCategories) {
                if (dontSearch.indexOf(f) === -1) { // this takes from initalData in the dim/group builder - we only want strings - numbers are 0
                    isAll.push(f);
                }
            }
        }
        modeRelevantParams.reqId = generateId();
        modeRelevantParams.allSearch = isAll;
        // set type/mode to params
        modeRelevantParams.type = mode;
        return modeRelevantParams;
    }

    let getdata = function(time) {
        if (!time) {
            // if no time amd start, fetch it
            time = angular.copy($scope.main.getTime());
            // get end
            let endTime = $scope.main.dataObjects[model.tableIdentifiers.key].time.dimension.bottom(1);
            if (endTime.length > 0) {
                time.end = endTime[0].time;
            }
        }
        // set start value to the end (since we get the last/latest data first) - this is reduced per data notify/return
        model.loadStart = time.end;
        // get specific/relevant params for this table
        let modeRelevantParams = paramsSanitize(angular.copy($scope.main.dataObjects[model.tableIdentifiers.key].filters), $scope.main.currentMode);
        // also assign surrent mode to the tables settings (for doing searches on)
        $scope.main.dataObjects[model.tableIdentifiers.key].settings.type = $scope.main.currentMode;
        // assign the reassigned req id (set in changetable)
        modeRelevantParams.reqId = $scope.main.manualSearchId;
        // reset launched status - to trigger table dimension group rebuild
        $scope.main.dataObjects[model.tableIdentifiers.key].launched = false;
        // return a new fetchstream obj
        return new fetchStream($scope.main.dataObjects[model.tableIdentifiers.key].settings.get.call, $scope.main.dataObjects[model.tableIdentifiers.key].settings.get.socket, modeRelevantParams, time)
            .then(function(type) {
                if (type !== $scope.main.currentMode) {
                    return
                }
                model.complete = true;
                // stop the table spinner as soon as the resolve comes in
                usSpinnerService.stop(model.tableIdentifiers.id);
                // if table finishes without being launched
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    $scope.main.emptyResponseTryNext($scope.main.currentMode);
                }
            }, function(err) {
                // console.log(err)
                // var r = confirm('An Error has occured, please click ok to refresh the page or try again in a few minutes\n'+err.message);
                // if (r == true) {
                //     x = 'Reloading page now';
                //     $window.location.reload();
                // } else {
                //     x = 'Please reload the page in a few minutes';
                // }
            }, function(result) {
                if (result.type !== $scope.main.currentMode) {
                    return
                }
                if (result.reqId !== $scope.main.manualSearchId) {
                    return
                }
                $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    // with our first data return, we can build dimensions and groups for our data
                    $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function() {
                        // initalize rows
                        $scope.$broadcast('init', model.tableIdentifiers);
                        if (result.min) {
                            model.loadStart = result.min;
                        }
                    }, function(err) {
                        console.log('error')
                        console.log(err)
                    })
                } else {
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                    $scope.$broadcast('updatedData', model.tableIdentifiers.id);
                }
            });
    }

    $scope.main.emptyResponseTryNext = function(previousType) {
        let pIndex = -1,
            t = false;
        for (let i = 0, len = model.sidebarItems.length; i < len; i++) {
            // loop through sidebar items and find our current mode and mark the index as pIndex
            if (model.sidebarItems[i].select === previousType) {
                pIndex = i;
            }
            // if pindex is set (not -1) and i is at least one index in front of our current with a count > 0, assign the type as the next to go to
            if ((i > pIndex) && (pIndex !== -1) && (model.sidebarItems[i].count > 0)) {
                t = model.sidebarItems[i].select;
                break;
            }
        }
        // if there is another type with a count > 0
        if (t) {
            // go to the new table
            model.changeTable(t, true);
        }
    }

    model.changeTable = function(type, emptyInital, requery) {
        $scope.main.dataObjects[model.tableIdentifiers.key].settings.render = {
                once: true,
                has: false
            }
            // emptyInital tells us that the inital set of data was empty and not 'launched'
        if (typeof emptyInital === 'undefined') {
            emptyInital = false;
        }
        // set table incomplete status - triggering spinner
        model.complete = false;
        // switch page mode
        $scope.main.currentMode = type;
        // get a query id
        $scope.main.manualSearchId = generateId();
        // push new settings to settigns obj
        for (let s in tableSettings[$scope.main.currentMode]) {
            $scope.main.dataObjects[model.tableIdentifiers.key].settings[s] = tableSettings[$scope.main.currentMode][s];
        }
        // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
        if ($scope.main.dataObjects[model.tableIdentifiers.key].launched) {
            // clear data in table
            $scope.main.dataObjects[model.tableIdentifiers.key].dimension.filterAll(); // clear all filters
            // clear time related dimensions
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove(); // remove records
        }
        $scope.main.dataObjects[model.tableIdentifiers.key].cf = new crossfilter([]); // replace cf
        // build a new table instance
        $scope.$broadcast('table-build', model.tableIdentifiers);
        // dont start the spinner if the table loads faster than building group dim
        if (!model.complete) {
            // start table spinner right before init, but after build
            setTimeout(function() {
                usSpinnerService.spin(model.tableIdentifiers.id);
            })
        }
        // run data fetch / notify function
        if (!requery) {
            getdata(false);
        }
    }

    function getProperCurrentMode(callback) {
        for (let s in model.sidebarItems) {
            let modeRelevantParams = paramsSanitize(killChain, model.sidebarItems[s].select);
            if ((modeRelevantParams.include.length === killChain.include.length) && (modeRelevantParams.exclude.length === killChain.exclude.length)) {
                model.changeTable(model.sidebarItems[s].select, false, true)
                return modeRelevantParams;
                break;
            }
        }

        return false;
    }

    socketIo('/api/search').then(function(socket) {
        // first register our data object
        let registerSettings = {
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: false, // TODO: if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                grouping: ['id'],
                get: {
                    call: 'search',
                    socket: socket
                },
                searchCategories: {
                    'vector': 'Vector',
                }
            }
            // push new settings to settigns obj
        for (let s in tableSettings[$scope.main.currentMode]) {
            // ignore search categories. below well send all search categories to populate the dropdown
            if (s !== 'searchCategories') {
                registerSettings[s] = tableSettings[$scope.main.currentMode][s];
            }
        }
        // find any and all search categoies and put them in settings pre register
        for (let se in tableSettings) {
            for (let v in tableSettings[se].searchCategories) {
                if (!registerSettings.searchCategories.hasOwnProperty(v)) {
                    registerSettings.searchCategories[v] = tableSettings[se].searchCategories[v]
                }
            }
        }
        $scope.main.registerVisual(registerSettings)
            // fetch the data when the object is registered
            .then(function(result) {
                model.tableIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // put the the modified (above) settings back after register
                for (let s in tableSettings[$scope.main.currentMode]) {
                    $scope.main.dataObjects[model.tableIdentifiers.key].settings[s] = tableSettings[$scope.main.currentMode][s];
                }
                // build table
                $scope.$broadcast('table-build', model.tableIdentifiers);
                // get and set time
                let time = angular.copy($scope.main.getTime());
                model.loadStart = time.end;
                model.loadEnd = time.end;
                // only send paramaters that this mode can filter on to avoid cassandra errors
                // note: we can only include items (since if there are any at this point, they are from a killchain link)
                let modeRelevantParams = paramsSanitize(killChain, $scope.main.currentMode);
                if ((modeRelevantParams.include.length !== killChain.include.length) || (modeRelevantParams.exclude.length !== killChain.exclude.length)) {
                    modeRelevantParams = getProperCurrentMode();
                }
                let includedLen = killChain.include.length;
                let excludedLen = killChain.exclude.length;
                if (includedLen > 0) {
                    for (let i = 0; i < includedLen; i++) {
                        let keys = Object.keys(killChain.include[i]);
                        let key = keys[0];
                        $scope.main.addFilter(key, killChain.include[i][key], 'include', true, key);
                        // $scope.main.updateFilterStore(key, killChain.include[i][key], 'include', true, key);
                    }
                }
                if (excludedLen > 0) {
                    for (let i = 0; i < excludedLen; i++) {
                        let keys = Object.keys(killChain.exclude[i]);
                        let key = keys[0];
                        $scope.main.addFilter(key, killChain.exclude[i][key], 'exclude', true, key);
                        // $scope.main.updateFilterStore(key, killChain.exclude[i][key], 'exclude', true, key);
                    }
                }

                // dont start the spinner if the table loads faster than building group dim
                if (!model.complete) {
                    // start table spinner right before init, but after build
                    setTimeout(function() {
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    })
                }
                if (modeRelevantParams) {
                    // also assign surrent mode to the tables settings (for doing searches on)
                    $scope.main.dataObjects[model.tableIdentifiers.key].settings.type = $scope.main.currentMode;
                    // assign this isntance of the id to the request
                    modeRelevantParams.reqId = $scope.main.manualSearchId;
                    // set ALL killchain items into filter store / search bar
                    return new fetchStream(result.settings.get.call, result.settings.get.socket, modeRelevantParams);
                }
            })
            // run the extra params and stuff crossfilter
            .then(function(type) {
                if (type !== $scope.main.currentMode) {
                    return
                }
                model.complete = true;
                // stop the table spinner as soon as the resolve comes in
                usSpinnerService.stop(model.tableIdentifiers.id);
                // if table finishes without being launched
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    // after table is set to 'launched', add any items in the killchain to the searchbar and global filters
                    // note: we only have includes from kill chain
                    $scope.main.emptyResponseTryNext($scope.main.currentMode);
                }
            }, function(err) {
                // console.log(err)
                // var r = confirm('An Error has occured, please click ok to refresh the page or try again in a few minutes\n'+err.message);
                // if (r == true) {
                //     x = 'Reloading page now';
                //     $window.location.reload();
                // } else {
                //     x = 'Please reload the page in a few minutes';
                // }
            }, function(result) {
                if (result.type !== $scope.main.currentMode) {
                    return
                }
                if (result.reqId !== $scope.main.manualSearchId) {
                    return
                }
                // add data to the new crossfilter object
                $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    // with our first data return, we can build dimensions and groups for our data
                    $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function() {
                        // initalize rows
                        $scope.$broadcast('init', model.tableIdentifiers);
                        if (result.min) {
                            model.loadStart = result.min;
                        }
                    }, function(err) {
                        console.log('error')
                        console.log(err)
                    })
                } else {
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                    $scope.$broadcast('updatedData', model.tableIdentifiers.id);
                }
            })

        // let includedLen = killChain.include.length;
        // let excludedLen = killChain.exclude.length;

        // COUNTS
        let getcount = function(killChain, index) {
                let stream = new fetchStream(killChain.type, socket, killChain)
                    .then(function(result) {
                        model.sidebarItems[index].doneLoading = true;
                        stream = null;
                    }, function(err) {
                        // console.log(err)
                        // var r = confirm('An Error has occured, please click ok to refresh the page or try again in a few minutes\n'+err.message);
                        // if (r == true) {
                        //     x = 'Reloading page now';
                        //     $window.location.reload();
                        // } else {
                        //     x = 'Please reload the page in a few minutes';
                        // }
                    }, function(result) {
                        // if (result.reqId !== $scope.main.manualSearchId) { return }
                        model.sidebarItems[index].count = result;
                    })
            }
            // on load, if there are items in the killchain, do a count for each table item
        if ((killChain.include.length > 0) || (killChain.exclude.length > 0)) {
            for (let i = 0, len = model.sidebarItems.length; i < len; i++) {
                let modeRelevantParams = paramsSanitize(killChain, model.sidebarItems[i].select);
                model.sidebarItems[i].count = 0; // set item to 0
                if ((modeRelevantParams.include.length === killChain.include.length) && (modeRelevantParams.exclude.length === killChain.exclude.length)) {
                    // if any relavent params, get the count
                    getcount(modeRelevantParams, i);
                } else {
                    // otherwise set spinner to false / done to true
                    model.sidebarItems[i].count = 0;
                    model.sidebarItems[i].doneLoading = true;
                }
            }
        } else {
            // otherwise for every sidebar item, get default counts
            for (let i = 0, len = model.sidebarItems.length; i < len; i++) {
                let modeRelevantParams = paramsSanitize(killChain, model.sidebarItems[i].select);
                model.sidebarItems[i].count = 0; // set item to 0
                model.sidebarItems[i].doneLoading = false; // emable spinner
                getcount(modeRelevantParams, i);
            }
        }

        $scope.$on('manualSearchFired', function(event, identifiers) {
            if (identifiers.key !== model.tableIdentifiers.key) {
                return
            }
            for (let index = 0, len = model.sidebarItems.length; index < len; index++) {
                model.sidebarItems[index].count = 0; // set each count in sidebar to 0
                // get relavent params for each mode
                let modeRelevantParams = paramsSanitize(angular.copy($scope.main.dataObjects[model.tableIdentifiers.key].filters), model.sidebarItems[index].select);
                // if no filters exist AND no relavent filters, get all the counts
                if ((modeRelevantParams.include.length === 0) && (modeRelevantParams.exclude.length === 0) && ($scope.main.dataObjects[model.tableIdentifiers.key].filters.include.length === 0) && ($scope.main.dataObjects[model.tableIdentifiers.key].filters.exclude.length === 0)) {
                    model.sidebarItems[index].doneLoading = false; // set spinner - getcount will turn it off when finished
                    getcount(modeRelevantParams, index);
                } else if ((modeRelevantParams.include.length > 0) || (modeRelevantParams.exclude.length > 0)) {
                    // otherwise if any relevant params exist in either exclude or exlcude, get the data
                    model.sidebarItems[index].doneLoading = false; // set spinner - getcount will turn it off when finished
                    getcount(modeRelevantParams, index);
                } else {
                    // otherwise remove the spinner
                    model.sidebarItems[index].doneLoading = true; // remove existing spinner
                }
            }
        })

        $scope.$on('$destroy', function() {
            socket.disconnect();
        });
    })
}

ctrl.$inject = ['$scope', 'Global', '$http', 'timeFormat', 'fetchStream', '$window', '$location', 'socketIo', 'generateId', 'settings', 'usSpinnerService', '$state', '$stateParams'];
module.exports = ctrl;



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/search/search.js
 **/